<template>
  <div class="notification" :class="[notification.type]">
    <div class="text">
      {{ notification.text }}
    </div>
    <div class="close" @click="onCloseNotification">
      <svg-icon
        :width="'10'"
        :height="'10'"
        icon="app-icons/close"
        fill="#fff"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SvgIcon from './SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      closeTimer: 0,
    };
  },

  computed: {
    ...mapGetters('application/notifications', ['getNotification']),

    /**
     * Returns the notification object
     */
    notification() {
      return this.getNotification(this.id);
    },
  },

  mounted() {
    this.closeTimer = setTimeout(
      () => this.delete({ id: this.id }),
      this.notification.delay
    );
  },

  methods: {
    ...mapActions('application/notifications', ['delete']),

    /**
     * Event listener: the notification close button has been pressed
     */
    onCloseNotification() {
      this.delete({ id: this.id });
    },
  },
};
</script>

<style scoped lang="scss">
.notification {
  border-radius: 3px;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  margin: 10px 0 0 0;
  transition: all 0.5s ease;

  &.INFO {
    background: #2d7736;
    border: 1px solid #66c140;
  }

  &.ERROR {
    background: #8e3420;
    border: 1px solid #e23009;
  }

  .text {
    padding-right: 10px;
    color: #fff;
  }

  .close {
    opacity: 0.5;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
